<template>
    <div id="body">
         <Logo />
         <Toast />
       
        <div id="sign" class="grid grid-flow-col grid-cols-2 gap-10 items-center;">
            <SideImage />
            <div class="form-box">
            <div class="container-head">
            <PrevBtn v-if="steps > 1" @click="prevBtn"/> 
            <Stepprogress :steps="steps"/>
            </div>
            <div id="Steps">
         <h3>Create an Account</h3>
         
                <p>By continuing you agree with our terms of service and Privacy Policy </p>

        <Step1 :form = 'form' v-if="steps === 1" @nextBtn= 'nextBtn' />
         <Step2 :form = 'form' v-else-if="steps === 2" @doneBtn= 'doneBtn' />

        </div>
        </div>

        </div>
          <p v-if="message">{{message.email[0] && message.password[0]}}</p>
    </div>
</template>
<script>
import Toast from 'primevue/toast';
import {mapActions} from 'vuex' 
import {mapGetters} from 'vuex' 
import Step1 from '../components/Step1.vue';
import Step2 from '../components/Step2.vue';
import Logo from '../components/Logo';
import Stepprogress from '../components/Steps-progress.vue'
import SideImage from '../components/SideImage';
import PrevBtn from '../components/PrevBtn';
export default {
    name: 'CreateAccount',
    data() {
        return {
            
            password: '',
            steps: 1,
            form: {
                fullname: '',
                email: '',
                phone: null,
                password: '',
                password_confirmation: '',
                address: '',
                city: '',
                state: ''

            }
        }
    },
    computed: {
         ...mapGetters({
            message : 'auth/message'
        }),
    },
    methods: {
        ...mapActions({
            signUp: 'auth/signUp'
        }),
        nextBtn(){
            this.steps += 1

            console.log(this.step)
        },
       
         prevBtn(){
            this.steps -= 1
        },
        doneBtn(){
            
            
            this.signUp(this.form).then(() => {
                this.$router.replace({path: '/dashboard' }) }).catch((err) => {
                console.log(err.response)
                })
        }
    
    },
    components: {
        Step1,
         Step2,
        Logo,
        SideImage,
        PrevBtn,
        Stepprogress,
       Toast

    },
    mounted() {
        
    }
}
</script>
<style lang="scss" >
@import '../assets/styles/sign';
#body {
    width: 90%;
    font-size: 90%;
    margin: 0 auto;
}
.grid {
    align-items: center;
}
.p-dropdown {
    width: 95%
}
.logo {
    margin: 1.5em 0 !important;
}
.arrow {
    margin: 0 !important;
}
@media (max-width: 995px) {
    #sign {
        display: block;
        .ads {
            display: none
        }
    }
}
</style>